import { useState } from "react";

// Extracting account email/passwords to single function for reuse
export function UserLoginState() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [emailErrorMessage, setEmailErrorMessage] = useState<
        string | undefined
    >(undefined);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<
        string | undefined
    >(undefined);
    const [verifyPasswordErrorMessage, setVerifyPasswordErrorMessage] =
        useState<string | undefined>(undefined);

    return {
        email,
        setEmail,
        password,
        setPassword,
        confirmPassword,
        setConfirmPassword,
        emailErrorMessage,
        setEmailErrorMessage,
        passwordErrorMessage,
        setPasswordErrorMessage,
        verifyPasswordErrorMessage,
        setVerifyPasswordErrorMessage,
    };
}

